/* unplugin-vue-components disabled */import { render } from "./NavbarMainMenu.vue?vue&type=template&id=7ce7a44e&ts=true"
import script from "./NavbarMainMenu.vue?vue&type=script&lang=ts"
export * from "./NavbarMainMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__